module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray-f63480776ee73ea161601706643a6355.png";